import { engine } from './player/engine.svelte.ts';
import { ticker } from './ticker.svelte.ts';

/**
 * The angle showing the match of the banner on screen, when that is not the
 * main picture already -- the one a click (or OK on the remote) jumps to.
 * Only angles linked to the fixture count; guessing by channel name would jump
 * to the wrong match as often as to the right one.
 */
export function bannerJumpTarget(): string | null {
  const f = ticker.banners[0]?.fixture;
  if (!f) return null;
  const angle = engine.angles.find((a) => a.fixtureProvider === f.provider && a.fixtureExternalId === f.externalId);
  return angle && angle.id !== engine.mainAngleId ? angle.id : null;
}

/** Makes the banner's match the main picture and lets the next banner come. */
export function jumpToBanner(): boolean {
  const target = bannerJumpTarget();
  if (!target) return false;
  engine.setMain(target);
  ticker.dismissBanner();
  return true;
}
